// WhatsApp configuration — change the number here only
export const WHATSAPP_PHONE = "18329704583";

export function buildWhatsAppUrl(productName, eventDate) {
  let message;

  if (productName && eventDate) {
    message = `Hi, I'm interested in renting the ${productName} for ${eventDate}. Can you tell me if it's available?`;
  } else if (productName) {
    message = `Hi, I'm interested in renting the ${productName}. Can you tell me if it's available?`;
  } else {
    message = "Hi, I'm interested in renting a water slide. Can you help me?";
  }

  return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;
}